module.exports = __webpack_public_path__ + "static/media/home_left_half_circle.1abdeafd.svg";